var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVolumnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27899 8.64528C1.34039 7.6379 1.37109 7.13423 1.63212 6.64977C1.87061 6.20713 2.32692 5.77779 2.78323 5.56667C3.28267 5.3356 3.85514 5.3356 5.00007 5.3356C5.42679 5.3356 5.64016 5.3356 5.84683 5.3007C6.05115 5.26619 6.25038 5.20643 6.43996 5.12276C6.63172 5.03813 6.80984 4.92068 7.1661 4.68579L7.34854 4.56549C9.46767 3.16826 10.5272 2.46963 11.4167 2.77317C11.5872 2.83136 11.7523 2.91537 11.8997 3.01898C12.6687 3.55935 12.7271 4.8166 12.8439 7.33111C12.8872 8.26219 12.9167 9.05903 12.9167 9.50228C12.9167 9.94553 12.8872 10.7424 12.8439 11.6734C12.7271 14.1879 12.6687 15.4452 11.8997 15.9855C11.7523 16.0892 11.5872 16.1732 11.4167 16.2314C10.5272 16.5349 9.46767 15.8363 7.34854 14.439L7.1661 14.3188C6.80984 14.0839 6.63172 13.9664 6.43996 13.8818C6.25038 13.7981 6.05115 13.7384 5.84683 13.7039C5.64016 13.6689 5.42679 13.6689 5.00007 13.6689C3.85514 13.6689 3.28267 13.6689 2.78323 13.4379C2.32692 13.2268 1.87061 12.7974 1.63212 12.3548C1.37109 11.8703 1.34039 11.3666 1.27899 10.3593C1.26083 10.0613 1.25 9.77094 1.25 9.50228C1.25 9.23361 1.26083 8.94328 1.27899 8.64528Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 4.5C16.6641 4.5 17.9141 6 17.9141 9.5C17.9141 13 16.6641 14.5 16.6641 14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C15 7 15.4167 7.75 15.4167 9.5C15.4167 11.25 15 12 15 12",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVolumnIcon);
export default __webpack_public_path__ + "static/media/WhiteVolumnIcon.6ee3670e1b2119637fdedc336a2ce074.svg";
export { ForwardRef as ReactComponent };